import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {PersonLoginService} from "../../services/person-login-service";
import { Router } from "@angular/router";

import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {Checkbox} from "../../model/checkbox";
import {BrandID} from "../../enums/brand-id";
import {MatCheckbox} from "@angular/material/checkbox";
import {StringUtils} from "../../utils/string-utils";
import {forkJoin, Observable} from "rxjs";
import {OrganizationProjectProductTypeService} from "../../services/organization-projectproducttype-service";
import {OrgunitXProjectProductType} from "./orgunit-x-projectproducttype";
import {SellableProjectProductType} from "../../enums/sellable-project-product-type";
import {ProjectProductType} from "../../enums/project-product-type";
import {OrganizationBrandsService} from "../../services/organization-brands-service";

@Component({
    selector: 'app-organization-brands',
    imports: [
    FormsModule,
    MatButton,
    MatIcon,
    MatCheckbox
],
    templateUrl: './organization-brands.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './organization-brands.component.css'
})
export class OrganizationBrandsComponent implements OnChanges, OnInit {
  private readonly organizationBrandsService = inject(OrganizationBrandsService);
  private readonly organizationProjectProductTypeService = inject(OrganizationProjectProductTypeService);
  private readonly personLoginService = inject(PersonLoginService);
  private readonly router = inject(Router);
  readonly organizationId = input.required<string>({ alias: 'organization-id' });


  readonly checkboxes = signal<Checkbox[]>([]);
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    this.initialize();
  }

  public save(): void {
    let getCalls: Observable<string>[] = [];
    let brandIDArray: string[] = [];
    this.organizationBrandsService.deleteByOrgUnitId(this.organizationId()).subscribe({
      next: () => {
        this.organizationProjectProductTypeService.deleteByOrgUnitId(this.organizationId()).subscribe({
          next: () => {
            this.checkboxes().forEach(cb => {
              if (cb.checked) {
                let ppt: OrgunitXProjectProductType = this.getOrgunitXProjectProductType(SellableProjectProductType[cb.id as keyof typeof SellableProjectProductType]);
                const pptObservable = this.organizationProjectProductTypeService.insert(this.organizationId(), ppt.projectProductType, ppt.brandID);
                getCalls.push(pptObservable);
                brandIDArray.push(ppt.brandID);
                pptObservable.subscribe({
                  next: async (results) => {
                  },
                  error: (error) => this.handleError(error)
                });

                const observable = this.organizationBrandsService.insert(this.organizationId(), ppt.brandID);
                getCalls.push(observable);
                observable.subscribe({
                  next: async (results) => {
                  },
                  error: (error) => this.handleError(error)
                });
              }
            });

            forkJoin([...getCalls]).subscribe(results => {
              this.personLoginService.setBrandsKey(brandIDArray);
            });
          },
          error: (error) => this.handleError(error)
        });
      },
      error: (error) => this.handleError(error)
    });
  }

  public backToOrganizationDetail(): void {
    this.router.navigate(['organization/' + this.organizationId()]);
  }

  private backToOrganizationMaster(): void {
    this.router.navigate(['organization']);
  }

  private getOrgunitXProjectProductType(sellableProjectProductType: SellableProjectProductType): OrgunitXProjectProductType {
    let x: OrgunitXProjectProductType = new OrgunitXProjectProductType();

    switch (sellableProjectProductType) {
      case SellableProjectProductType.CLM_COMMERCIAL:
        x.projectProductType = ProjectProductType.COM;
        x.brandID = BrandID.CLM;
        break;
      case SellableProjectProductType.CLM_RESIDENTIAL:
        x.projectProductType = ProjectProductType.RES;
        x.brandID = BrandID.CLM;
        break;
      case SellableProjectProductType.IEC_COMMERCIAL:
        x.projectProductType = ProjectProductType.COM;
        x.brandID = BrandID.IEC;
        break;
    }

    return x;
  }

  private createCheckboxes(orgunitXProjectProductTypes: OrgunitXProjectProductType[]) {

    for (const sellable of Object.values(SellableProjectProductType)) {
      let checkbox: Checkbox = new Checkbox();
      checkbox.id = sellable.toString();
      checkbox.title = sellable.toString();
      checkbox.checked = this.isChecked(sellable, orgunitXProjectProductTypes);
      this.checkboxes.update(current => [...current, checkbox]);
    }
  }

  private isChecked(sellable: SellableProjectProductType, orgunitXProjectProductTypes: OrgunitXProjectProductType[]): boolean {
    let checked: boolean = false;
    for (const ppt of orgunitXProjectProductTypes) {
      if ((ppt.brandID == BrandID.CLM && ppt.projectProductType == ProjectProductType.COM && sellable == SellableProjectProductType.CLM_COMMERCIAL)
        || (ppt.brandID == BrandID.CLM && ppt.projectProductType == ProjectProductType.RES && sellable == SellableProjectProductType.CLM_RESIDENTIAL)
        || (ppt.brandID == BrandID.IEC && ppt.projectProductType == ProjectProductType.COM && sellable == SellableProjectProductType.IEC_COMMERCIAL)) {
        checked = true;
      }
    }

    return checked;
  }

  private initialize(): void {
    this.initializeFromRouteParams();
  }

  private handleError(error: any) {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  private initializeFromRouteParams(): void {
    let idString: string = this.organizationId();
    if (idString && idString.length > 0) {
      if (!this.personLoginService.isInternalOrRsm()) {
        this.backToOrganizationMaster();
      } else {
        this.organizationProjectProductTypeService.getByOrgUnitId(idString).subscribe(value => {
          this.createCheckboxes(value);
        });
      }
    } else {
      this.backToOrganizationMaster();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['organizationId'].firstChange) {
      this.initializeFromRouteParams();
    }
  }
}
